(() => {
  const init = () => {
    const root = document.querySelector('[data-bl-ego]');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const groupSource = root.querySelector('[data-bl-product-groups]');
    let groups;
    try { groups = JSON.parse(groupSource.textContent); } catch { return; }
    const grid = document.querySelector('collection-component');
    if (!grid) return;
    let selected = 'all';
    const count = root.querySelector('[data-bl-count]');
    const empty = root.querySelector('[data-bl-empty]');
    const navLinks = root.querySelectorAll('.bl-ego__categories [data-bl-filter]');
    const cards = () => Array.from(grid.querySelectorAll('.product-grid__item[data-product-id]'));
    const applyCategory = () => {
      let visible = 0;
      cards().forEach(card => {
        const matches = selected === 'all' || groups[card.dataset.productId] === selected;
        card.classList.toggle('bl-ego-hidden', !matches);
        if (matches) visible++;
      });
      count.textContent = visible === 1 ? count.dataset.singularPattern : count.dataset.countPattern.replace('__COUNT__', String(visible));
      empty.hidden = visible > 0;
      navLinks.forEach(link => {
        if (link.dataset.blFilter === selected) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    };
    root.querySelectorAll('[data-bl-filter]').forEach(link => {
      link.addEventListener('click', () => {
        selected = link.dataset.blFilter;
        applyCategory();
      });
    });
    const gridUpdates = new MutationObserver(applyCategory);
    gridUpdates.observe(grid, { childList: true, subtree: true });
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!reducedMotion.matches && root.classList.contains('bl-ego--motion')) {
      const pause = root.querySelector('[data-bl-pause]');
      pause.hidden = false;
      pause.addEventListener('click', () => {
        const paused = root.classList.toggle('bl-ego--paused');
        pause.setAttribute('aria-pressed', String(paused));
        pause.textContent = paused ? pause.dataset.resumeLabel : pause.dataset.pauseLabel;
      });
      const reveal = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('bl-ego-revealing');
          reveal.unobserve(entry.target);
        });
      }, { threshold: .08 });
      cards().forEach(card => reveal.observe(card));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
